<template>
  <v-dialog
    v-model="showModal"
    persistent
    :max-width="next ? '800px' : '500px'"
    style="min-width: 500px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1" v-if="!modalloading">
        <v-col cols="12" md="12" class="pa-0">
          <v-list subheader dense class="mandate-select-list">
            <v-list-item-group v-if="!next" mandatory v-model="selectedType">
              <v-list-item
                value="deregister"
                v-if="showTabDeregister"
                class="mandate-select-item"
              >
                <v-list-item-content>
                  <v-list-item-title
                    ><span>{{ $t('Išregistruoti') }}</span></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                value="enter-basis"
                v-if="showTabEnterBasis"
                class="mandate-select-item"
              >
                <v-list-item-content>
                  <v-list-item-title
                    ><span>{{
                      $t(
                        'Įrašyti pasibaigimo požymį asmens atžvilgiu ties asmeniu'
                      )
                    }}</span></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                value="enter-basis-action"
                v-if="showTabEnterBasisAction"
                class="mandate-select-item"
              >
                <v-list-item-content>
                  <v-list-item-title
                    ><span>{{
                      $t(
                        'Įrašyti pasibaigimo požymį asmens atžvilgiu ties paslauga'
                      )
                    }}</span></v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <span class="pt-2 pb-1" style="font-size: 21px">
          <strong>{{ getTitle }}</strong>
          {{ getTitleType }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col v-if="!next" cols="12" md="12">
            <el-simple-table :items="tebleItems" />
          </v-col>
          <v-col v-if="next" cols="12" md="12">
            <el-PDF-viewer download :file="pdfFile" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <el-button
          color="secondary"
          @click.native="cancel()"
          :loading="loading || requestLoading"
          title="Atšaukti"
        />
        <el-button
          v-if="!next"
          color="primary"
          @click.native.stop="goNext()"
          :loading="loading || requestLoading"
          title="Tęsti"
        />
        <el-button
          v-if="showDeregisterBtn"
          color="danger"
          @click.native.stop="submit()"
          :loading="loading || requestLoading"
          title="Išregistruoti"
        />
        <el-button
          v-if="showAttributeTypeBtn"
          color="primary"
          @click.native.stop="submit()"
          :loading="loading || requestLoading"
          title="Įvesti požymį"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ModalIregInactiveAction',
  props: {
    injournalId: [String, Number],
    requestLoading: Boolean,
    formData: Object,
    documentKind: String,
    basis: String,
    basisText: String,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      classifiers: {},
      searchBy: null,
      loading: false,
      next: false,
      pdfFile: {},
      selectedType: 0,
      mandateActionsList: [],
    }
  },
  computed: {
    showAttributeTypeBtn() {
      return this.selectedType != 'deregister' && this.next
    },
    showDeregisterBtn() {
      return this.selectedType === 'deregister' && this.next
    },
    showTabDeregister() {
      return this.formData.tab_deregister
    },
    showTabEnterBasis() {
      return this.formData.tab_enter_basis
    },
    showTabEnterBasisAction() {
      return this.formData.tab_enter_basis_action
    },
    getTitle() {
      return `${this.getDocumentNo}`
    },
    tebleItems() {
      let items = [
        {
          title: 'Požymis',
          value:
            this.documentKind == 'PP' || this.documentKind == 'ITPSP'
              ? 'Prokūra šio asmens atžvilgiu pasibaigė'
              : 'Įgaliojimas šio asmens atžvilgiu pasibaigė',
          tooltip:
            'Ireg. Pagrindinis. Dokumentai. Gautų dokumentų žurnalas. Dokumento peržiūra tvarkymas. Modalas. Požymis',
          hide: this.documentKind == 'PP' || this.documentKind == 'ITPSP',
        },
        {
          title: '',
          value: this.formData?.person_role || '',
          enumName: 'userRoles',
        },
        {
          title: 'Vardas',
          value: this.formData?.person_name || '',
        },
        {
          title: 'Pavardė',
          value: this.formData?.person_lastname || '',
        },
        {
          title: 'Asmens kodas',
          value: this.formData?.person_code || '',
        },
      ]
      switch (this.selectedType) {
        case 'deregister':
          let deregisterAddList = [
            {
              title: 'Pasibaigimo pagrindas',
              value: this.basis || '',
              enumName: 'inJournalBasis',
              hide: this.basis == 'notary-action',
            },
            {
              title: 'Pasibaigimo pagrindas',
              value: this.basisText || '',
              hide: this.basis != 'notary-action',
            },
            {
              title: 'Pasibaigimo data',
              value: moment().format('YYYY-MM-DD HH:mm'),
            },
          ]
          return [...items, ...deregisterAddList]
        case 'enter-basis':
          let basisAddList = [
            {
              title: 'Požymio data',
              value: moment().format('YYYY-MM-DD HH:mm'),
            },
          ]
          return [...items, ...basisAddList]
        case 'enter-basis-action':
          let basisActionAddList = [
            {
              title: 'Veiksmo / paslaugos kodas, pavadinimas',
              checkboxList: true,
              list: this.mandateActionsList,
            },
            {
              title: 'Požymio data',
              value: moment().format('YYYY-MM-DD HH:mm'),
            },
          ]
          return [...items, ...basisActionAddList]
        default:
          return items
      }
    },
    getTitleType() {
      switch (this.selectedType) {
        case 'deregister':
          return 'Išregistravimas'
        case 'enter-basis':
        case 'enter-basis-action':
          return 'Įvesti požymį'
        default:
          return ''
      }
    },
    getDocumentNo() {
      return this.formData.journal_no
    },
    showModal() {
      return true
    },
  },

  created() {
    this.getSelectedType()
    this.mandateActionsList = this.getMandateActionsList()
    this.modalloading = false
  },
  methods: {
    getMandateActionsList() {
      let arr = []
      this.formData.mandate_actions.map((item) => {
        const index = this.formData.mapped_actions.findIndex(
          (formItem) => formItem.action_id === item.action_id
        )
        arr.push({
          text: `(${item.code}) ${item.title_lt}`,
          value: index > -1,
          id: item.id,
        })
      })
      return arr
    },
    getSelectedType() {
      this.selectedType = this.formData.suggestion
    },
    getPdfFile(confirm) {
      this.loading = true
      let data = {}
      if (this.selectedType === 'enter-basis-action') {
        let mandateArr = []
        this.mandateActionsList.map((item) => {
          if (item.value) {
            mandateArr.push(item.id)
          }
        })
        if (mandateArr.length == 0) {
          return this.$root.$emit(
            'DATA_ERROR_TEXT',
            this.$t('Turi būti pasirinkta bent viena paslauga')
          )
        }
        data = {
          decision: this.selectedType,
          preview: confirm ? 0 : 1,
          mandate_actions: mandateArr,
        }
      } else {
        data = {
          decision: this.selectedType,
          preview: confirm ? 0 : 1,
        }
      }

      let url = `in-journals/${this.injournalId}/nirvar/decision`
      this.$axios
        .post(url, data)
        .then((res) => {
          this.pdfFile = res.data
          this.pdfFile.original_filename = 'Peržiūra.pdf'
          confirm && this.closeModal(true)
          this.next = true
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR_TEXT', err.response.data.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    goNext() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.getPdfFile()
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal(update) {
      this.$emit('close-modal', update)
    },
    cancel() {
      this.closeModal()
    },
    submit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.getPdfFile(true)
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
